import { UserRoles } from 'constants/roles'
import { Rule } from 'ui/molecules/Form/components/FormItem/types'

type FormValuesSetting = {
  [key: string]: {
    required: {
      [UserRoles.Supplier]: boolean
      [UserRoles.Operator]: boolean
    }
    disabled: {
      [UserRoles.Supplier]: boolean
      [UserRoles.Operator]: boolean
    }
    validationRules?: Rule[]
  }
}

export const getValidationRules = (
  formValue: FormValuesSetting['key'],
  role: UserRoles
) =>
  formValue.required[role]
    ? formValue.validationRules
    : formValue.validationRules?.filter((rule) => rule.type !== 'required')

export const getRequiredRule = (ruleMessage: string): Rule[] => [
  { type: 'required', message: ruleMessage },
]
